import { useCallback } from 'react'

import { useDbContext } from '../contexts/DbContext'
// TODO extract repository actions to a separate file
export function useBusinessLogic () {
  // const [items, setItems] = useState([])
  const db = useDbContext().current

  /**
   * Fetch items from the database
   * @param {boolean} isFilterByLiked - Whether to filter by liked items
   * @returns {Promise<Array>} - The items from the database
   */
  const fetchItemsDb = useCallback(
    async (isFilterByLiked=false) => {

      const options = isFilterByLiked ? { 'liked': true } : {}
      const something = await db.allDocs({ include_docs: true, attachments: true, ...options })
      const data = something.rows.filter((r) => {
        if (isFilterByLiked) {
          return r.doc.liked === true
        }
        // don't filter
        return true
      }).map((r) => {
        console.log('r---', r.doc)
        return r.doc
      })

      const sortedData = data.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })
      // console.log('sorted Data', sortedData)
      // return sortedData
      /////
      // console.log('sorted', sortedData)
      // setItems(sortedData)
      return sortedData
    },
    [db]
  )

  const createItem = useCallback(
    async (newItem) => {
      try {
        const { files, ...docFields } = newItem
        // First, create the base document
        const postResult = await db.post(docFields)

        // If files are provided, attach them to the created document
        if (files && files.length > 0) {
          console.log('files in useBusinessLogic', files)
          const docId = postResult.id
          const doc = await db.get(docId)
          let res = null
          // Attach each file
          for (const file of files) {
            console.log('putting attachment', file)
            try {
              res = await db.putAttachment(
                docId, 
                file.name || 'attachment', 
                res?.rev || doc._rev, 
                file, 
                file.type || 'application/octet-stream'
              )
              console.log('res', res)
              console.log('doc', doc._rev)
            } catch (e ) {
              console.error('Error putting attachment', e)
            }
            
            console.log('attachment put')
          }
        }
      } catch (error) {
        console.error('Error creating item:', error)
      }
    },
    [db]
  )

  // const likeItem = useCallback(
  //   async (item) => {
  //     try {
  //       console.log('likeItem in useBusinessLogic', item)
  //       // Get the latest version of the document to avoid conflicts
  //       const latestDoc = await db.get(item._id)
  //       const likedItem = { 
  //         ...latestDoc, 
  //         liked: !latestDoc.liked,
  //         _rev: latestDoc._rev // Use the latest revision
  //       }
        
  //       const result = await db.put(likedItem)
        
  //       // Update local state with the new document
  //       const updatedItem = { ...likedItem, _rev: result.rev }
  //       // setItems(
  //       //   items.map((i) => (i._id === item._id ? updatedItem : i))
  //       // )
  //       console.log('updatedItem in useBusinessLogic', updatedItem)
  //       return updatedItem
  //     } catch (error) {
  //         console.error('Error liking item:', error)
  //         // Refresh the items to get the current state
  //         await fetchItemsDb()
  //     }
  //   },
  //   [db, fetchItemsDb]
  // )
  

  const updateItem = useCallback(
    async (updatedItem) => {
      try {
        // console.log('updating item in useBusinessLogic', updatedItem)
        
        // Get the latest version of the document to avoid conflicts
        const latestDoc = await db.get(updatedItem._id)
        const itemToUpdate = { 
          ...latestDoc, 
          ...updatedItem,
          _rev: latestDoc._rev, // Use the latest revision
          updatedAt: new Date()
        }
        
        const result = await db.put(itemToUpdate)
        // console.log('result of update', result)
        
        // Update local state with the new document
        const finalUpdatedItem = { ...itemToUpdate, _rev: result.rev }
        // console.log('Updating local state with:', finalUpdatedItem)
        // console.log('Current items before update:', items)
        return finalUpdatedItem
        // const newItems = items.map((item) => (item._id === updatedItem._id ? finalUpdatedItem : item))
        // // console.log('New items after update:', newItems)
        
        // setItems(newItems)
        
        // // Also refresh from database to ensure consistency
        // await fetchItemsDb()
        
        // console.log('end of updateItem in useBusinessLogic')
        // return finalUpdatedItem;
      } catch (error) {
        console.error('Error updating item:', error)
        
          await fetchItemsDb()
          throw error

      }
    },
    [db, fetchItemsDb]
  )

  /**
   * Like/dislike an item
   * @param {Object} item - The item to like
   * @returns {Promise<Object>} - The liked item
   */
  const likeItem = useCallback(
    async (item) => {
      const updatedItem = await updateItem({ ...item, liked: !item.liked })
      return updatedItem
    },
    [updateItem]
  )

  const deleteItem = useCallback(
    async (item) => {
      await db.remove(item._id, item._rev) // Remove the item using its id and revision
    },
    [db]
  )

  return { deleteItem, updateItem, createItem, fetchItemsDb, likeItem }
}
